// Utility functions that can be used in both client and server components

export function prettyFormatNumber(number: number): string {
    let formattedCount: string
    if (!number) return "0"

    // Values just under a unit boundary would round up to "1000K" / "1000M"; promote them.
    if (number >= 999_950_000) {
        formattedCount = (number / 1e9).toFixed(1).replace(/\.0$/, "") + "B"
    } else if (number >= 999_950) {
        formattedCount = (number / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
    } else if (number >= 1e3) {
        formattedCount = (number / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
    } else {
        formattedCount = number.toString()
    }

    return formattedCount
}

export function cloakImageURL(url: string): string {
    const encodedUrl = btoa(encodeURIComponent(url).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(parseInt(p1, 16))))
    return `https://www.outfame.com/influencer-images/${encodedUrl}`
}

/**
 * Display label for the two official country names that run to seven words. Pages show the
 * shorter form in running text; slugs, ISO codes and emoji lookups keep the official name.
 */
const DISPLAY_COUNTRY_NAMES: Record<string, string> = {
    "Saint Helena, Ascension and Tristan da Cunha": "St Helena, Ascension & Tristan da Cunha",
    "South Georgia and the South Sandwich Islands": "South Georgia & South Sandwich Islands"
}

/** Some stored nationalities are lists ("Kittitian or Nevisian"); prose uses the first form. */
export function displayNationality(nationality: string): string {
    return nationality.split(/,\s*|\s+or\s+/)[0]
}

const COUNTRIES_WITH_ARTICLE = new Set([
    "United States",
    "United Kingdom",
    "Netherlands",
    "Philippines",
    "Czech Republic",
    "Dominican Republic",
    "United Arab Emirates",
    "UAE",
    "Bahamas",
    "Gambia",
    "Maldives",
    "Central African Republic",
    "Democratic Republic of the Congo",
    "Republic of the Congo"
])

/** "the United States", "the Cayman Islands", "Canada": for running text after a preposition. */
export function withArticle(country: string): string {
    const name = displayCountryName(country)
    return COUNTRIES_WITH_ARTICLE.has(country) || /Islands$/.test(country) || /Virgin Islands/.test(country) ? `the ${name}` : name
}

/** "1 follower" / "2 followers". */
export function countOf(n: number, singular: string, plural = `${singular}s`): string {
    return `${prettyFormatNumber(n)} ${n === 1 ? singular : plural}`
}

export function displayCountryName(country: string): string {
    return DISPLAY_COUNTRY_NAMES[country] ?? country
}
